import MainLayout from "@/components/layout/admin/MainLayout.vue";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {
  required,
  maxLength,
  minValue
} from "vuelidate/lib/validators";
import axios from "axios";
import CONFIG from "@/assets/js/config.custom.js";
import Loading from 'vue-loading-overlay';
import {isEnglishNumber, maxInteger8, decimalWithTwoPlaces} from "@/utils/validators";

export default {
  name: "positionEdit",
  components: {
    MainLayout,
    flatPickr,
    Loading
  },

  data() {
    return {
      CONFIG,
      positionData: null,
      isError: false,
      submitted: false,
      disabled: false,
      isLoading: false,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      positionExists: false
    };
  },

  validations: {
    positionData: {
      position_name: {
        required,
        maxLength: maxLength(100)
      },
      description: {
        maxLength: maxLength(1000)
      },
      basic_salary: {
        isEnglishNumber,
        maxInteger8,
        decimalWithTwoPlaces,
        minValue: minValue(0)
      },
      daily_salary: {
        isEnglishNumber,
        maxInteger8,
        decimalWithTwoPlaces,
        minValue: minValue(0)
      },
      hourly_salary: {
        isEnglishNumber,
        maxInteger8,
        decimalWithTwoPlaces,
        minValue: minValue(0)
      }
    }
  },

  methods: {
    confirmUpdate() {
      if (this.disabled) return;
      this.submitted = true;
      this.disabled = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.disabled = false;
        return;
      }
      this.update();
    },

    update() {
      this.disabled = true;
      let request = {
        position_name: this.positionData.position_name,
        type: this.positionData.type,
        description: this.positionData.description,
        basic_salary: this.positionData.basic_salary,
        daily_salary: this.positionData.daily_salary,
        hourly_salary: this.positionData.hourly_salary,
      };
      axios.put('position/'+ this.$route.params.id, request)
        .then(res => {
          if (res.data.success == true) {
            this.$notification.success("Position Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: 'positionList'
            })
          } else {
            this.disabled = false;
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          }
        }).catch((error) => {
          this.disabled = false;
          this.isLoading = false;
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            } else if (error.response.status == 422) {
              let errors = error.response.data.errors;
              if (errors.position_name[0]) {
                this.$notification.error(errors.position_name[0], {
                  timer: 3,
                  position: "bottomCenter",
                });
              }
            }
          }
        });
    },

    getPositionDetail() {
      this.isLoading = true;
      axios.get('/position/detail/' + this.$route.params.id)
      .then((response) => {
        if (response.data.success == true) {
          let data = response.data.data;
          this.positionData = data.positions;
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else {
          console.error(err);
        }
      })
      .finally(() => {
        this.isLoading = false;
      })
    },

    showList() {
      this.$router.push({
        name: "positionList"
      });
    },
  },

  mounted() {
    this.isLoading = true;
    this.getPositionDetail();
  },
};
